import { FC } from 'react';

interface SkipBackwardIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const SkipBackwardIcon: FC<SkipBackwardIconProps> = ({ width = 16, height = 16, color = 'white' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
      <g id="skip-back">
        <path
          id="Icon"
          d="M3.33325 12.6667V3.33337M10.9336 4.05311L7.04108 7.16711C6.68518 7.45183 6.50723 7.59419 6.44281 7.76618C6.38632 7.91697 6.38632 8.08311 6.44281 8.23391C6.50723 8.40589 6.68518 8.54825 7.04108 8.83297L10.9336 11.947C11.4884 12.3908 11.7657 12.6127 11.9992 12.613C12.2022 12.6132 12.3943 12.5209 12.5209 12.3622C12.6666 12.1797 12.6666 11.8245 12.6666 11.114V4.88604C12.6666 4.17557 12.6666 3.82034 12.5209 3.63789C12.3943 3.47921 12.2022 3.38691 11.9992 3.38712C11.7657 3.38738 11.4884 3.60929 10.9336 4.05311Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default SkipBackwardIcon;
